import login from "../api/login";
import developer from "../api/developer";
import news from "../api/news";

export default {
  login,
  developer,
  news
};
